import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import MenuInfoAdmin from "../menuRole/menuInfoAdmin";
import MenuInfoDoctor from "../menuRole/menuInfoMedical";
import MenuInfoLab from "../menuRole/menuInfoPersonalLaboratory";
import MenuInfoAdminLab from "../menuRole/menuInfoAdminLaboratory";
import MenuInfoHospital from "../menuRole/menuInfoHospital";
import MenuInfoHospitalPersonnel from "../menuRole/menuInfoHospitalPersonal";
import MenuInfoExecutive from "../menuRole/menuInfoExecutive";
import MenuInfoPatient from "../menuRole/menuInfoPatient";

const MobileMenuList = ({
  user,
  navMenu,
  menuActive,
  navigate,
  setOpen,
  setOpenModal,
  subMenuHover,
  setSubMenuHover,
  childMenuHover,
  setChildMenuHover,
}) => {
  const renderProfileByRole = () => {
    const role = user?.["auth"]?.["role"]?.[0];

    const sharedProps = { 
      setOpenModal: setOpenModal,
      setOpenMenu: setOpen
    };
    
    const roleComponents = {
      ADMIN: <MenuInfoAdmin {...sharedProps}/>,
      MEDICAL_PERSONNEL: <MenuInfoDoctor {...sharedProps}/>,
      LABORATORY_PERSONNEL: <MenuInfoLab {...sharedProps}/>,
      LABORATORY_ADMIN: <MenuInfoAdminLab {...sharedProps}/>,
      HOSPITAL: <MenuInfoHospital {...sharedProps}/>,
      HOSPITAL_PERSONNEL: <MenuInfoHospitalPersonnel {...sharedProps}/>,
      EXECUTIVE: <MenuInfoExecutive {...sharedProps}/>,
      PATIENT: <MenuInfoPatient {...sharedProps}/>,
    };

    return roleComponents[role] || null;
  };

  const NavMenuItem = ({ label, link, hasSub, onClick, isActive }) => (
    <div
      onClick={(e) => {
        if (hasSub) e.stopPropagation();
        onClick(e);
      }}
      className={`flex items-center justify-between w-full p-3 rounded-md cursor-pointer transition-all
      ${isActive ? "text-white bg-[#3EC6CB]" : "text-black hover:bg-gray-50"}`}
    >
      <span className="text-[16px] font-medium">{label}</span>
      {hasSub && (
        <FontAwesomeIcon
          icon={faAngleRight}
          className={isActive ? "text-white" : "text-[#26A0A4]"}
        />
      )}
    </div>
  );

  const SubMenuOverlay = ({ title, items, onBack, onNext, currentActive }) => (
    <div className="absolute top-0 left-0 z-20 w-full h-full bg-white">
      <div className="pb-1 bg-[#FFE380]">
        <div
          onClick={(e) => {
            e.stopPropagation();
            onBack();
          }}
          className="flex items-center gap-2 p-4 bg-[#3EC6CB] text-white cursor-pointer"
        >
          <FontAwesomeIcon icon={faAngleLeft} />
          <span className="font-medium">ย้อนกลับ ({title})</span>
        </div>
      </div>
      <div className="flex flex-col p-4 gap-y-2">
        {items.map((item) => (
          <NavMenuItem
            key={item.name}
            label={item.name}
            isActive={currentActive === item.link}
            hasSub={item.submenu?.length > 0}
            onClick={() => {
              if (item.submenu?.length > 0) onNext(item);
              else {
                navigate(item.link);
                setOpen(false);
              }
            }}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className="flex flex-col p-0 z-50 !left-[unset] !right-[10px] mt-[20px] overflow-hidden min-w-[280px] border-none shadow-2xl">
      
        {user?.["auth"]?.["role"]?.[0] && (
          <div className="w-full z-100 pb-1 bg-[#FFE380]">
            <div className="flex justify-center bg-[#3EC6CB] w-full py-4 px-2">
              {renderProfileByRole()}
            </div>
          </div>
        )}

      <div className="relative flex flex-col p-4 gap-y-2 min-h-[300px] z-9">
        {navMenu.map((item) => (
          <NavMenuItem
            key={item.name}
            label={item.name}
            isActive={menuActive === item.link}
            hasSub={item.submenu?.length > 0}
            onClick={() => {
              if (item.submenu?.length > 0)
                setSubMenuHover({ name: item.name, status: true });
              else {
                navigate(item.link);
                setOpen(false);
              }
            }}
          />
        ))}

        <NavMenuItem
          label="ติดต่อเรา"
          isActive={menuActive === "/contact"}
          onClick={() => navigate("/contact")}
        />
        <NavMenuItem
          label="คำถามที่พบบ่อย"
          isActive={menuActive === "/ansQandA"}
          onClick={() => navigate("/ansQandA")}
        />
        <NavMenuItem
          label="แบบประเมินความพึงพอใจ"
          isActive={menuActive === "/usagePolicy"}
          onClick={() => navigate("/usagePolicy")}
        />

        {subMenuHover.status && (
          <SubMenuOverlay
            title={subMenuHover.name}
            items={
              navMenu.find((m) => m.name === subMenuHover.name)?.submenu || []
            }
            currentActive={menuActive}
            onBack={() => setSubMenuHover({ name: "", status: false })}
            onNext={(item) =>
              setChildMenuHover({ name: item.name, status: true })
            }
          />
        )}

        {childMenuHover.status && (
          <SubMenuOverlay
            title={childMenuHover.name}
            items={
              navMenu
                .find((m) => m.name === subMenuHover.name)
                ?.submenu?.find((s) => s.name === childMenuHover.name)
                ?.submenu || []
            }
            currentActive={menuActive}
            onBack={() => setChildMenuHover({ name: "", status: false })}
            onNext={() => {}}
          />
        )}
      </div>

      {!user?.["auth"]?.["role"]?.[0] && (
        <div className="bg-[#FFE380] w-full pt-1">
          <div className="flex flex-col gap-3 p-5 bg-[#3EC6CB]">
            <button
              onClick={() => navigate("/login")}
              className={`w-full py-2.5 rounded-full text-sm font-bold shadow-md transition-all ${menuActive === "login" ? "bg-[#076B71] text-white" : "bg-white text-[#076B71]"}`}
            >
              เข้าสู่ระบบ
            </button>
            <button
              onClick={() => navigate("/register")}
              className={`w-full py-2.5 rounded-full text-sm font-bold border-2 border-white transition-all ${menuActive === "register" ? "bg-white text-[#076B71]" : "bg-transparent text-white"}`}
            >
              สมัครใช้งาน
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileMenuList;
